import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'authority-labs-certificate-end-line',
  templateUrl: './certificate-end-line.component.html',
  styleUrls: ['./certificate-end-line.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CertificateEndLineComponent {}
